<div class="wrapper">
  <p-inputMask
    *ngIf="displayDateInput === true"
    [(ngModel)]="value"
    [mask]="dateMask"
    [placeholder]="datePlaceholder"
    (onInput)="dateValidator()"
    (onBlur)="dateValidator(); onBlurEvent()"
    (onFocus)="onFocusEvent()"
    (onComplete)="dateValidator()"
    [autoClear]="false"
    [ngClass]="{
      'valid-date': isValidDateTime && inputControl.valid,
      'invalid-date': !isValidDateTime || !inputControl.valid
    }"
    [unmask]="true"
    class="date-input"
  ></p-inputMask>

  <p-inputMask
    *ngIf="displayTimeInput === true"
    [(ngModel)]="value"
    [mask]="timeMask"
    [placeholder]="timePlaceholder"
    (onInput)="timeValidator()"
    (onBlur)="timeValidator(); onBlurEvent()"
    (onFocus)="onFocusEvent()"
    (onComplete)="timeValidator()"
    [autoClear]="false"
    [ngClass]="{
      'valid-date': isValidDateTime && inputControl.valid,
      'invalid-date': !isValidDateTime || !inputControl.valid
    }"
    [unmask]="true"
    class="time-input"
  ></p-inputMask>

  <p-inputMask
    *ngIf="displayDateTimeInput === true"
    [(ngModel)]="value"
    [mask]="dateTimeMask"
    [placeholder]="dateTimePlaceholder"
    (onInput)="dateTimeValidator()"
    (onBlur)="dateTimeValidator(); onBlurEvent()"
    (onFocus)="onFocusEvent()"
    (onComplete)="dateTimeValidator()"
    [autoClear]="false"
    [ngClass]="{
      'valid-date': isValidDateTime && inputControl.valid,
      'invalid-date': !isValidDateTime || !inputControl.valid
    }"
    [unmask]="true"
  ></p-inputMask>

  <p-inputMask
    *ngIf="displayDateTimeWithSecondsInput === true"
    [(ngModel)]="value"
    [mask]="dateTimeWithSecondsMask"
    [placeholder]="dateTimeWithSecondsPlaceholder"
    (onInput)="dateTimeWithSecondsValidator()"
    (onBlur)="dateTimeWithSecondsValidator(); onBlurEvent()"
    (onFocus)="onFocusEvent()"
    (onComplete)="dateTimeWithSecondsValidator()"
    [autoClear]="false"
    [ngClass]="{
      'valid-date': isValidDateTime && inputControl.valid,
      'invalid-date': !isValidDateTime || !inputControl.valid
    }"
    [unmask]="true"
  ></p-inputMask>
</div>
